// extracted by mini-css-extract-plugin
export default {"panel":"panel__UiMXq","sectionHeader":"sectionHeader__Jagi7","panel--postAuthNav3":"panel--postAuthNav3__Y0yqo","sectionHeaderWithBorder":"sectionHeaderWithBorder__h0lom"};